import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AppStore {

    constructor() {
    }

    private alreadyLoadedBimModule = false;

    private showGlobalSpinner$ = new BehaviorSubject<string>(null);

    setGlobalSpinnerIfLoadingBimModule(text) {
        if (!this.alreadyLoadedBimModule) {
            this.showGlobalSpinner$.next(text);
        }
    }

    setBimModuleLoaded() {
        this.alreadyLoadedBimModule = true;
    }

    dismissGlobalSpinner() {
        this.showGlobalSpinner$.next(null);
    }

    getGlobalSpinner(): Observable<string> {
        return this.showGlobalSpinner$.asObservable();
    }
}
